<template>
  <div class="brochure-section">
    <h1 class="brochure-title">Download the E-Brochure Today!</h1>
    <p class="brochure-description">
      Experience the pinnacle of modern living at Arina East Residences, an exclusive freehold gem at the city fringe. With 107 thoughtfully designed units, premium amenities, and seamless connectivity, this tranquil yet vibrant residence offers the perfect blend of luxury and convenience. Just 3 minutes from Katong Park MRT, enjoy effortless access to top lifestyle hubs. Download the e-brochure now and take the first step toward your dream home.
    </p>
    
    <v-card class="brochure-card" elevation="4">
      <v-img
        src="@/assets/3_Brochure.png"
        aspect-ratio="16/9"
        class="brochure-img"
        cover
      ></v-img>
    </v-card>

    <!-- Enquire Button -->
    <v-btn
      color="primary"
      class="brochure-button"
      @click="scrollToSection('enquire')"
    >
      Download Brochure
    </v-btn>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutView',
  props: {
    scrollToSection: Function, // Define the prop to accept the method
  },
});
</script>

<style scoped>
.brochure-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  background-color: #F7F4ED; /* Light background */
  border-radius: 12px; /* Rounded corners */
  margin: 20px auto;
  max-width: 800px; /* Limit width for better readability */
  width: 100%; /* Ensure it takes full width on smaller screens */
}

.brochure-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50; /* Dark text color */
  margin-bottom: 16px;
}

.brochure-description {
  font-size: 1.1rem;
  color: #666; /* Subdued text color */
  line-height: 1.6;
  margin-bottom: 24px;
  max-width: 600px; /* Limit width for better readability */
}

.brochure-card {
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.brochure-img {
  width: 100%;
  height: auto;
}

.brochure-button {
  font-size: 1rem;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease; /* Smooth hover effects */
}

.brochure-button:hover {
  transform: translateY(-2px); /* Slight lift on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow on hover */
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .brochure-section {
    padding: 20px 10px; /* Reduce padding on mobile */
  }

  .brochure-title {
    font-size: 1.75rem; /* Smaller title on mobile */
  }

  .brochure-description {
    font-size: 1rem; /* Smaller description on mobile */
  }

  .brochure-button {
    font-size: 0.9rem; /* Smaller button text on mobile */
    padding: 10px 20px; /* Adjust padding for mobile */
    width: 100%; /* Full-width button on mobile */
  }
}
</style>